import { render, staticRenderFns } from "./PersonnelRecordCoursesDataTable.vue?vue&type=template&id=38b5b562"
import script from "./PersonnelRecordCoursesDataTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordCoursesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports